import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  zh: require('./locales/zh.json'),
  en: require('./locales/en.json')
}

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh',
  fallbackLocale: 'zh',
  messages
})

export default i18n
